import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { useI18n } from "../i18n";

const targetDate = () => {
  const now = new Date();
  const year = now.getMonth() > 11 ? now.getFullYear() + 1 : now.getFullYear();
  return new Date(`${year}-12-25T11:00:00`);
};

export const AnnouncementBanner = () => {
  const { t } = useI18n();
  const [days, setDays] = useState(null);

  useEffect(() => {
    const tick = () => {
      const diff = targetDate() - new Date();
      setDays(Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24))));
    };
    tick();
    const id = setInterval(tick, 60 * 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <section data-testid="announcement-banner" className="relative overflow-hidden bg-[#001489]">
      <div className="absolute inset-0 grain opacity-[0.15] pointer-events-none" />
      <div className="absolute -top-16 left-1/4 w-72 h-72 bg-[#E1000F] rounded-full blur-[120px] opacity-30" />
      <div className="absolute -bottom-16 right-1/4 w-72 h-72 bg-white rounded-full blur-[130px] opacity-10" />

      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-14 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
        <div className="shrink-0">
          <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-3xl bg-white/10 border border-white/15 backdrop-blur-xl flex items-center justify-center">
            <Gift className="text-white" size={40} />
          </div>
        </div>

        <div className="flex-1 text-center lg:text-left">
          <p className="font-mono-accent text-[11px] sm:text-xs uppercase tracking-[0.3em] text-[#38BDF8] mb-3">
            {t("ann.label")}
          </p>
          <h2 className="font-display font-black tracking-tighter text-2xl sm:text-3xl lg:text-4xl text-white leading-tight">
            {t("ann.title")}
          </h2>
          <p className="mt-3 text-white/70 max-w-2xl mx-auto lg:mx-0">
            {t("ann.desc1")}<b className="text-white">{t("ann.date")}</b>{t("ann.desc2")}
          </p>
        </div>

        <div className="shrink-0 text-center">
          <div className="font-display font-black text-5xl sm:text-6xl text-white tabular-nums leading-none" data-testid="announcement-countdown">
            {days === null ? "—" : days}
          </div>
          <div className="mt-2 font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#38BDF8]">
            {days === 1 ? t("ann.days_one") : t("ann.days_other")}
          </div>
        </div>
      </div>
    </section>
  );
};
